import { LocalComponent } from "~/ecs/base"

export class Repulsive extends LocalComponent {}
